import { User } from '_types/User'

export const getUser = (): User | null => {
  const session = sessionStorage.getItem('signSession')

  return session ? JSON.parse(session) : null
}

export const setUser = (user: User) => {
  sessionStorage.setItem('signSession', JSON.stringify(user))
}

export const clearStorage = () => {
  sessionStorage.clear()
}

export const getSsoAccessToken = (url: string) => {
  const hashIndex = url.indexOf('#')
  if (hashIndex === -1) return null
  const hashString = url.substring(hashIndex)
  const tokenRegex = /access_token=([^&]+)/
  const match = hashString.match(tokenRegex)
  return match ? match[1] : null
}
